module.exports = __webpack_public_path__ + "img/asian-fish-1.cee588c9.jpg";